
export {} from '@clayui/localized-input';
import __x__ from '@clayui/localized-input';export default __x__;